// import { formatNumber, getTooltipData } from "./index"; // Import helpers

// export default function EngagementKeyMetrics({
//  validData,
//  previousValidData,
//  totalFollowers,
//  prevFollowers,
//  totalReactions,
//  prevTotalReactions,
// }) {
// // -------------------------------------------------------
// // Engagement Metrics Calculations
// // -------------------------------------------------------
// // Total Engagement
// const engagementChangePct = prevTotalReactions
//  ? ((totalReactions - prevTotalReactions) / prevTotalReactions) * 100
//  : 0;

// const engagementRatePct = totalFollowers
//  ? (totalReactions / totalFollowers) * 100
//  : 0;

// // Reactions / 1K Fans
// const reactionsPerThousand = totalFollowers
//  ? (totalReactions / totalFollowers) * 1000
//  : 0;

// const prevReactionsPerThousand = prevFollowers
//  ? (prevTotalReactions / prevFollowers) * 1000
//  : 0;

// const reactionsPerThousandChangePct = prevReactionsPerThousand
//  ? ((reactionsPerThousand - prevReactionsPerThousand) / prevReactionsPerThousand) * 100
//  : 0;

// // -------------------------------------------------------
// // Build Metric Cards
// // -------------------------------------------------------
// return [
//  {
//   title: "Total Engagement",
//   color: "accent",
//   icon: "favorite",
//   count: formatNumber(totalReactions),
//   fullCount: totalReactions,
//   percentage: {
//    color: engagementChangePct >= 0 ? "success" : "error",
//    amount: `${engagementChangePct.toFixed(2)}%`,
//    tooltip: getTooltipData(totalReactions, prevTotalReactions, validData, previousValidData),
//   },
//  },
//  {
//   title: "Engagement Rate (%)",
//   color: "accent",
//   icon: "percent",
//   count: `${engagementRatePct.toFixed(2)}%`,
//  },
//  {
//   title: "Reactions / 1K Fans",
//   color: "accent",
//   icon: "bolt",
//   count: formatNumber(reactionsPerThousand),
//   fullCount: reactionsPerThousand,
//   percentage: {
//    color: reactionsPerThousandChangePct >= 0 ? "success" : "error",
//    amount: `${reactionsPerThousandChangePct.toFixed(2)}%`,
//    tooltip: getTooltipData(
//     reactionsPerThousand,
//     prevReactionsPerThousand,
//     validData,
//     previousValidData
//    ),
//   },
//  },
// ];
// }


// #######################################################

import { formatNumber, getTooltipData } from "./index"; // Import helpers

export default function EngagementKeyMetrics({
 validData,
 previousValidData,
 totalFollowers,
 prevFollowers,
 totalReactions,
 prevTotalReactions,
 // ⭐️ NEW PROPS FOR POST CLICKS
 totalPostClicks,
 prevTotalPostClicks,
}) {
// -------------------------------------------------------
// Engagement Metrics Calculations
// -------------------------------------------------------
// Total Engagement (based on Reactions)
const engagementChangePct = prevTotalReactions
 ? ((totalReactions - prevTotalReactions) / prevTotalReactions) * 100
 : 0;

const engagementRatePct = totalFollowers
 ? (totalReactions / totalFollowers) * 100
 : 0;

// Reactions / 1K Fans
const reactionsPerThousand = totalFollowers
 ? (totalReactions / totalFollowers) * 1000
 : 0;

const prevReactionsPerThousand = prevFollowers
 ? (prevTotalReactions / prevFollowers) * 1000
 : 0;

const reactionsPerThousandChangePct = prevReactionsPerThousand
 ? ((reactionsPerThousand - prevReactionsPerThousand) / prevReactionsPerThousand) * 100
 : 0;

// ⭐️ Total Post Clicks Change
const postClicksChangePct = prevTotalPostClicks
 ? ((totalPostClicks - prevTotalPostClicks) / prevTotalPostClicks) * 100
 : 0;

// -------------------------------------------------------
// Build Metric Cards
// -------------------------------------------------------
return [
 {
  title: "Total Engagement",
  color: "accent",
  icon: "favorite",
  count: formatNumber(totalReactions),
  fullCount: totalReactions,
  percentage: {
   color: engagementChangePct >= 0 ? "success" : "error",
   amount: `${engagementChangePct.toFixed(2)}%`,
   tooltip: getTooltipData(totalReactions, prevTotalReactions, validData, previousValidData),
  },
 },
 // ⭐️ NEW CARD: Total Post Clicks
 {
  title: "Total Post Clicks",
  color: "accent",
  icon: "touch_app", // Icon for interaction/clicks
  count: formatNumber(totalPostClicks),
  fullCount: totalPostClicks,
  percentage: {
   color: postClicksChangePct >= 0 ? "success" : "error",
   amount: `${postClicksChangePct.toFixed(2)}%`,
   tooltip: getTooltipData(totalPostClicks, prevTotalPostClicks, validData, previousValidData),
  },
 },
 {
  title: "Engagement Rate (%)",
  color: "accent",
  icon: "percent",
  count: `${engagementRatePct.toFixed(2)}%`,
 },
 {
  title: "Reactions / 1K Fans",
  color: "accent",
  icon: "bolt",
  count: formatNumber(reactionsPerThousand),
  fullCount: reactionsPerThousand,
  percentage: {
   color: reactionsPerThousandChangePct >= 0 ? "success" : "error",
   amount: `${reactionsPerThousandChangePct.toFixed(2)}%`,
   tooltip: getTooltipData(
    reactionsPerThousand,
    prevReactionsPerThousand,
    validData,
    previousValidData
   ),
  },
 },
];
}